import { useGetFirmsQuery } from '../../services/api/firmsService';
import { Button } from '../ui/catalyst/button';
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from '../ui/catalyst/dialog';
import { Field, Fieldset, Label } from '../ui/catalyst/fieldset';
import { Input } from '../ui/catalyst/input';
import { Select } from '../ui/catalyst/select';
import { DragDropFileInput } from './DragDropFileInput';

interface CreateDemandExampleModalProps {
  isOpen: boolean;
  title: string;
  firmId: string | null;
  selectedFile: File | null;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onTitleChange: (title: string) => void;
  onFirmChange: (firmId: string) => void;
  onFileChange: (file: File | null) => void;
}

export const CreateDemandExampleModal = ({
  isOpen,
  title,
  firmId,
  selectedFile,
  isLoading,
  onClose,
  onSubmit,
  onTitleChange,
  onFirmChange,
  onFileChange,
}: CreateDemandExampleModalProps) => {
  // Fetch firms for the dropdown
  const {
    data: firms,
    isLoading: firmsLoading,
    error: firmsError,
  } = useGetFirmsQuery({});

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Create Demand Example</DialogTitle>
      <DialogDescription>
        Upload a PDF and add a title to create a new demand example.
      </DialogDescription>

      <DialogBody>
        <Fieldset className="space-y-6">
          <Field>
            <Label>Title</Label>
            <Input
              value={title}
              onChange={(e) => onTitleChange(e.target.value)}
              placeholder="Enter example title"
            />
          </Field>

          <Field>
            <Label>Firm</Label>
            <Select
              value={firmId || ''}
              onChange={(e) => onFirmChange(e.target.value)}
              disabled={firmsLoading}
            >
              <option value="">
                {firmsLoading ? 'Loading firms...' : 'Select firm'}
              </option>
              {firmsError && (
                <option value="" disabled>
                  Error loading firms
                </option>
              )}
              {firms?.map((firm) => (
                <option key={firm.id} value={firm.id}>
                  {firm.name}
                </option>
              ))}
            </Select>
          </Field>

          <Field>
            <Label>Demand Letter File</Label>
            <DragDropFileInput
              selectedFile={selectedFile}
              onFileChange={onFileChange}
            />
          </Field>
        </Fieldset>
      </DialogBody>

      <DialogActions>
        <Button outline onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onSubmit} disabled={isLoading || !firmId}>
          {isLoading ? 'Creating...' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
